import React, { useState } from "react";
import { toast } from "sonner";
import { FISCAL_DEFAULTS } from "@/lib/printTemplates";
import { fiscalPrinters } from "@/lib/fiscal";
import { Button } from "@/components/ui/button";
import { Plug } from "lucide-react";
import { useConfigEditor, EditorBar, Field, Toggle, Panel } from "./common";

export default function FiscalTab() {
  const ed = useConfigEditor("fiscal", FISCAL_DEFAULTS);
  const [printers, setPrinters] = useState(null);
  const t = ed.value;
  if (!t) return null;
  const set = (patch) => ed.set((s) => ({ ...s, ...patch }));
  const test = async () => {
    try {
      const list = await fiscalPrinters(t);
      setPrinters(list);
      toast.success(`Връзката е успешна: ${Object.keys(list).length} устройство(а)`);
    } catch (e) { setPrinters({}); toast.error(`Няма връзка с ${t.url}. Стартирана ли е програмата ErpNet.FP на този компютър?`); }
  };
  return (
    <div data-testid="fiscal-tab">
      <EditorBar ed={ed} testid="fiscal">
        <Button variant="outline" onClick={test} className="gap-1" data-testid="fiscal-test"><Plug className="w-4 h-4" /> Провери връзката</Button>
      </EditorBar>
      <div className="grid lg:grid-cols-2 gap-4">
        <Panel title="Фискално устройство">
          <div className="rounded-xl bg-amber-50 border border-amber-200 p-3 text-sm text-amber-900">
            Обикновената бележка от термопринтера <b>не е фискален бон</b>. Законов фискален бон в България се издава само от регистрирано фискално устройство (ФУ), свързано с НАП.
          </div>
          <Toggle label="Използвай фискално устройство за крайните бележки" checked={t.enabled} onChange={(v) => set({ enabled: v })} testid="fiscal-enabled" />
          <Field label="Адрес на програмата ErpNet.FP" value={t.url} onChange={(v) => set({ url: v })} testid="fiscal-url" />
          <Field label="Идентификатор на устройството" value={t.printer_id} onChange={(v) => set({ printer_id: v })} placeholder="напр. dt517985" testid="fiscal-printer-id" />
          {printers && Object.keys(printers).length > 0 && (
            <div className="flex flex-wrap gap-2">
              {Object.entries(printers).map(([id, p]) => (
                <Button key={id} size="sm" variant={t.printer_id === id ? "default" : "outline"} onClick={() => set({ printer_id: id })}>{id} · {p.model || p.manufacturer || ""}</Button>
              ))}
            </div>
          )}
        </Panel>
        <Panel title="Данъчни групи (ДДС % → група във ФУ)">
          <p className="text-xs text-muted-foreground">Стандартно в България: група А (1) = 0%, Б (2) = 20%, Г (4) = 9%. Потвърдете с вашия сервиз.</p>
          {Object.keys(t.tax_groups).map((rate) => (
            <Field key={rate} label={`ДДС ${rate}%`} type="number" value={t.tax_groups[rate]} onChange={(v) => set({ tax_groups: { ...t.tax_groups, [rate]: v } })} testid={`fiscal-group-${rate}`} />
          ))}
        </Panel>
      </div>
    </div>
  );
}
